import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import { sublace, linkAttrs } from '../../common/sublace';
import { assetUrl } from './SublaceHero';

/** Подвал форума: знак, ссылки, Discord и строка о правах. */
export default class SublaceFooter extends Component {
  view() {
    const config = sublace();
    const links = config.footerLinks || [];
    return m("footer", {
      className: "SublaceFooter"
    }, m("div", {
      className: "container SublaceFooter-inner"
    }, m("div", {
      className: "SublaceFooter-brand"
    }, m("img", {
      src: assetUrl('img/mark-64.png'),
      alt: "",
      width: "36",
      height: "36"
    }), m("div", null, m("div", {
      className: "SublaceFooter-name"
    }, "SUBLACE"), m("div", {
      className: "SublaceFooter-text"
    }, config.footerText))), m("nav", {
      className: "SublaceFooter-links",
      "aria-label": "\u0421\u0441\u044B\u043B\u043A\u0438"
    }, links.map(link => {
      const {
        external,
        ...attrs
      } = linkAttrs(link);
      return m("a", attrs, link.icon ? m(Icon, {
        name: link.icon
      }) : null, link.label);
    }), config.discordUrl ? m("a", {
      href: config.discordUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, m(Icon, {
      name: "fab fa-discord"
    }), "Discord") : null), m("div", {
      className: "SublaceFooter-up"
    }, m("button", {
      type: "button",
      className: "Button Button--icon Button--flat",
      title: "\u041D\u0430\u0432\u0435\u0440\u0445",
      "aria-label": "\u041D\u0430\u0432\u0435\u0440\u0445",
      onclick: () => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }, m(Icon, {
      name: "fas fa-arrow-up"
    })))));
  }
}
flarum.reg.add('sublace-forum', 'forum/components/SublaceFooter', SublaceFooter);